import { render, staticRenderFns } from "./EmailStatsChart.vue?vue&type=template&id=650d43df&scoped=true&"
import script from "./EmailStatsChart.vue?vue&type=script&lang=js&"
export * from "./EmailStatsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d43df",
  null
  
)

export default component.exports